import { Text, Skeleton } from '@genial/components';
import { Utils } from '@genial/utils';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { cohortCellColumns, cohortCellGapHorizontal, cohortCellHeight } from '../../constants';
import { CohortCell, CohortCellTypes } from '../CohortCell';

export namespace CohortFooterTypes {
  export type Props = {
    isLoading?: boolean;
    annualPercentage?: number;
    monthValues?: CohortCellTypes.Props[];
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    gap: cohortCellGapHorizontal,
    justifyContent: 'center',
    height: cohortCellHeight,
    minHeight: cohortCellHeight,
  },
});

export const CohortFooter: React.FC<CohortFooterTypes.Props> = ({
  annualPercentage,
  monthValues,
  isLoading,
}) => {
  const cells = useMemo(() => {
    if (isLoading || monthValues === undefined) {
      return Array(cohortCellColumns)
        .fill(undefined)
        .map((_, index) => <CohortCell key={index} isLoading={isLoading} />);
    }

    return monthValues.map((item, index) => <CohortCell key={index} {...item} />);
  }, [isLoading, monthValues]);

  return (
    <View style={styles.container}>
      <Text flex={1} alignItems="center" display="flex">
        {isLoading ? <Skeleton width="100%" borderRadius="sm" height="inline.xxxs" /> : 'MÉDIA'}
      </Text>
      {cells}
      <Text flex={1} alignItems="center" display="flex">
        {isLoading ? (
          <Skeleton width="100%" borderRadius="sm" height="inline.xxxs" />
        ) : (
          Utils.Mask.Percentage(annualPercentage)
        )}
      </Text>
    </View>
  );
};
